// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"0":"auflage-3","42":"impressum","60":"auflage-2","78":"auflage-1","129":"autoren","773":"kapitel"}[chunkId] || chunkId) + "." + {"0":"502a172f","42":"9172abe0","60":"5ce59c4a","78":"861f3937","109":"e0bbbc8e","129":"11e9f875","134":"7215ffe5","370":"e26ba73b","773":"8c48d7a9"}[chunkId] + ".js";
};